import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { InventoryService } from '../../services/inventory.service';
import { PrintService } from '../../services/print.service'
import { ReportsService } from '../../services/reports.service'

import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-trending-products',
	templateUrl: './trending-products.component.html',
	styleUrls: ['./trending-products.component.scss']
})
export class TrendingProductsComponent {
@Input() customer = null;
@Input() vendor = null;
@Input() menuapp = true;
@ViewChild('print_table') printtable: ElementRef;
searchForm = null;
categories: any = [];
productlines: any = [];
filename: any = 'Top_100_Sales_';
brands: any = [];
user: any = [];
results: any = [];
salespeople: any = [];
sending: any = false;
loading = false;
reportResults: any = [];
sortedReportResults: any = [];
sortByColumn: string;
sortDirection: string;
summary: any = [];
color: any = 'blue';

constructor(private reportService: ReportsService, private printService: PrintService, private fb: UntypedFormBuilder, private inventoryService: InventoryService, private globalSearchService: GlobalSearchService) {}

ngOnInit(): void {
	this.color = this.globalSearchService.getColor();

	this.globalSearchService.user.subscribe(result => {
		this.user = result;
	});
	this.searchForm = this.fb.group({
		'customer': this.customer,
		'vendor': this.vendor,
		'limit' :100,
		'user':this.user.user.userid
	});
	this.inventoryService.getItemCategories().subscribe(c => {
		this.categories = c
	});
	this.inventoryService.getItemProductlines().subscribe(p => {
		this.productlines = p
	});

	this.inventoryService.getBrands().subscribe((results: any) => {
		this.brands = results;
	});
	this.reportService.getSalesPeople().subscribe((results: any) => {
		this.salespeople = results;
	});

	this.getData();
}

getData() {
	this.sending = true;
	this.loading = true;
	this.globalSearchService.aiDataAvailable$.next(null);
		
	this.inventoryService.customerTrendingProducts(this.searchForm.value).subscribe( (p:any) => {
		this.loading = false;
		this.sending = false;
		this.reportResults = p.results;
		setTimeout(() => {
				
			this.sendCustomerTrendToAI(this.customer, p.results)
		}, 100);

		this.summary = p.summary
		this.sortedReportResults= p.results;
	});
}
	
private sendCustomerTrendToAI(customer: any, trendingResults: any[]): void {
	  if (!customer || !trendingResults || trendingResults.length === 0) {return;}
	
	  const brandStats = {};
	  let totalSpend = 0;
	  let totalQty = 0;
	  let returnQty = 0;
	  const recentWeeks = 12;
	  const now = new Date();
	
	  // Parse trend data
	  const enrichedTrends = trendingResults.map(item => {
		const brand = item.brand || item.stockid?.substring(0, 2) || 'Unknown';
		totalSpend += item.salestotal || 0;
		totalQty += item.qtytotal || 0;
		if (item.qtytotal < 0) {returnQty += Math.abs(item.qtytotal);}
	
		// Count brands
		if (!brandStats[brand]) {brandStats[brand] = 0;}
		brandStats[brand] += item.qtytotal || 0;
	
		// Use only recent weekly sales for behavior classification
		const recentSales = (item.weekly_sales || []).slice(-recentWeeks);
	
		return {
		  stockid: item.stockid,
		  description: item.description,
		  brand: brand,
		  qtytotal: item.qtytotal,
		  salestotal: item.salestotal,
		  avg_price: item.avg_price,
		  avg_weekly: item.avg_weekly,
		  frequency: item.frequency,
		  growth_rate_pct: item.growth_rate_pct,
		  volatility: item.volatility,
		  slope: item.slope,
		  one_time_spike: item.one_time_spike,
		  recent_sales: recentSales,
		  weekly_sales: item.weekly_sales,
		};
	  });
	
	 // Sort and pick top 3 brands by volume
	 const topBrands = Object.entries(brandStats)
	   .sort(([, aQty], [, bQty]) => (Number(bQty) || 0) - (Number(aQty) || 0))
	   .slice(0, 3)
	   .map(([brand]) => brand);
	 
	 const uniqueProductCount = enrichedTrends.length;
	 const avgMonthlyQty = totalQty ? +(Number(totalQty) / 6).toFixed(2) : 0;
	 const avgMonthlySpend = totalSpend ? +(Number(totalSpend) / 6).toFixed(2) : 0;
	 const returnRate = totalQty > 0 ? +(Number(returnQty) / Number(totalQty) * 100).toFixed(1) : 0;
	 
	  const aiPayload = {
		customer_profile: {
		  id: customer.customer_id || customer.id || null,
		  name: customer.name || customer.customerName || '',
		  location: customer.location || customer.address || '',
		  email: customer.email || '',
		  phone: customer.phone || '',
		  assigned_salesrep: customer.salesrep || customer.rep || '',
		  last_order_date: customer.last_order_date || '',
		  total_unique_products: uniqueProductCount,
		  average_monthly_quantity: avgMonthlyQty,
		  average_monthly_spend: avgMonthlySpend,
		  return_rate_pct: returnRate,
		  top_brands: topBrands
		},
		trends: enrichedTrends,
	  };
	
	  console.log('📊 AI Trend Payload:\n', JSON.stringify(aiPayload, null, 2));
	
	  this.globalSearchService.aiDataAvailable$.next(aiPayload);
	  this.globalSearchService.aiDataContext$.next('customer_trend');
}

exportPdf() {
	const now = new Date();
	const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
	const data = {
		content: encoded,
		filename: this.filename + (now.getMonth() + 1) + now.getDate() + now.getFullYear(),
		title: `Trending Products - Created @ ${now.toLocaleString()}`,
		subtitle: this.getReportSubtitle()
	}

	this.printService.pdf(data).subscribe((result: any) => {
		this.globalSearchService.downloadPdf(result.content, data.filename);
	});
}

exportXls() {
	const now = new Date();
	const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
	const data = {
		content: encoded,
		filename: this.filename + (now.getMonth() + 1) + now.getDate() + now.getFullYear(),
		title: `Trending Products - Created @ ${now.toLocaleString()}`,
		subtitle: this.getReportSubtitle()
	}

	this.printService.xls(data).subscribe((result: any) => {
		this.globalSearchService.downloadXls(result.content, data.filename);
	});
}

getReportSubtitle() {
	let out = '';

	if (this.customer) {

		out += ' for Customer ' + this.customer.customer.brname;

	} else if (this.vendor) {
		out += ' for Vendor ' + this.vendor.name;
	}
	return out;
}

sortBy(property: string): void {
	if (this.sortByColumn === property) {
		// Toggle sort direction if the same column is clicked
		this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
	} else {
		// Default to ascending order when a new column is clicked
		this.sortDirection = 'asc';
		this.sortByColumn = property;
	}

	this.sortedReportResults.sort((a, b) => {
		// Check if the property values are numeric
		const isNumeric = !isNaN(parseFloat(a[property])) && isFinite(a[property]) && !isNaN(parseFloat(b[property])) && isFinite(b[property]);

		if (isNumeric) {
			// Sort as numbers if the property values are numeric
			const numA = parseFloat(a[property]);
			const numB = parseFloat(b[property]);
			return this.sortDirection === 'asc' ? numA - numB : numB - numA;
		} else {
			// Sort as strings if the property values are not numeric
			const comparison = a[property].localeCompare(b[property]);
			return this.sortDirection === 'asc' ? comparison : -comparison;
		}
	});
}


sortAscending(data: any[], property: string): any[] {
	return data.sort((a, b) => {
		if (a[property] < b[property]) {return -1;}
		if (a[property] > b[property]) {return 1;}
		return 0;
	});
}

sortDescending(data: any[], property: string): any[] {
	return data.sort((a, b) => {
		if (a[property] > b[property]) {return -1;}
		if (a[property] < b[property]) {return 1;}
		return 0;
	});
}

getSortIcon(property: string): string {
	if (this.sortByColumn !== property) {
		return 'fa-sort text-muted';
	}
	return this.sortDirection === 'asc' ? 'fa-sort-up text-success' : 'fa-sort-down text-danger';
}

getTotalSales(): number {
	if (!this.reportResults || !Array.isArray(this.reportResults)) {
		return 0;
	}
	return this.reportResults.reduce((sum, item) => sum + (item.salestotal || 0), 0);
}

getTotalQuantity(): number {
	if (!this.reportResults || !Array.isArray(this.reportResults)) {
		return 0;
	}
	return this.reportResults.reduce((sum, item) => sum + (item.qtytotal || 0), 0);
}

getAveragePrice(): number {
	const totalSales = this.getTotalSales();
	const totalQty = this.getTotalQuantity();
	return totalQty > 0 ? totalSales / totalQty : 0;
}

getGrowingTrendsCount(): number {
	if (!this.reportResults || !Array.isArray(this.reportResults)) {
		return 0;
	}
	return this.reportResults.filter(r => r.slope > 0).length;
}

getTrialSpikesCount(): number {
	if (!this.reportResults || !Array.isArray(this.reportResults)) {
		return 0;
	}
	return this.reportResults.filter(r => r.one_time_spike).length;
}

getStableTrendsCount(): number {
	if (!this.reportResults || !Array.isArray(this.reportResults)) {
		return 0;
	}
	return this.reportResults.filter(r => r.slope >= -0.5 && r.slope <= 0.5 && !r.one_time_spike).length;
}

getTrendBadgeClass(slope: number): string {
	if (slope > 1) return 'bg-success text-light';
	if (slope > 0.5) return 'bg-info text-light';
	if (slope > -0.5) return 'bg-secondary text-light';
	if (slope > -1) return 'bg-warning text-dark';
	return 'bg-danger text-light';
}

getTrendIcon(slope: number): string {
	if (slope > 0) return 'fa-arrow-up';
	if (slope < 0) return 'fa-arrow-down';
	return 'fa-minus';
}

getVolatilityBadgeClass(volatility: number): string {
	if (volatility < 0.3) return 'bg-success text-light';
	if (volatility < 0.6) return 'bg-info text-light';
	if (volatility < 1.0) return 'bg-warning text-dark';
	return 'bg-danger text-light';
}

getRowClass(item: any): string {
	if (item.one_time_spike) return 'table-warning';
	if (item.slope > 1) return 'table-success';
	if (item.slope < -1) return 'table-danger';
	return '';
}

}
